<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav #snav mode="over" position="end">
    <!-- Side nav content -->
    <div class="closeIconWrapper">
      <button mat-icon-button class="closeIcon w-auto h-auto" (click)="close()">
        <mat-icon class="text-4xl w-auto h-auto">close</mat-icon>
      </button>
    </div>
    <ul id="sidenavMenu">
      <a routerLink="/dashboard" (click)="close()">
        <li>
          <div class="menu-icons dashboard-menu-icon"></div>
          <div class="menutext">Dashboard</div>
        </li>
      </a>
      <a routerLink="/energy-chart" (click)="close()">
        <li class="">
          <div class="menu-icons performance-menu-icon"></div>
          <div class="menutext">Performance</div>
        </li>
      </a>
      <a routerLink="/price-chart" (click)="close()">
        <li class="">
          <div class="menu-icons price-menu-icon"></div>
          <div class="menutext">Strom-Preis</div>
        </li>
      </a>
      <a routerLink="/energy-balance" (click)="close()">
        <li class="">
          <div class="menu-icons balance-menu-icon"></div>
          <div class="menutext">Energie-Bilanz</div>
        </li>
      </a>
      <a routerLink="/devices" (click)="close()">
        <li class="mb-8">
          <div class="menu-icons devices-menu-icon"></div>
          <div class="menutext">Deine Anlage(n)</div>
        </li>
      </a>

      <div class="menu-divider"></div>

      <a target="_blank" href="https://energyplus.at/privatkunden-blog/" (click)="close()">
        <li class="lower-menu-items first-lower-element">
          <div class="menu-icons"></div>
          <div class="menutext">News</div>
        </li>
      </a>

      <a target="_blank" href="https://energyplus.at/privatkunden-kontakt/" (click)="close()">
        <li class="lower-menu-items">
          <div class="menu-icons"></div>
          <div class="menutext">Support</div>
        </li>
      </a>

      <a target="_blank" href="https://energyplus.at/privatkunden-kontakt/" (click)="close()">
        <li class="lower-menu-items">
          <div class="menu-icons"></div>
          <div class="menutext">Kontakt</div>
        </li>
      </a>

      <a target="_blank" href="https://energyplus.at/privatkunden-energieberatung/" (click)="close()">
        <li class="lower-menu-items">
          <div class="menu-icons"></div>
          <div class="menutext">Über Energy+ Brain</div>
        </li>
      </a>

      <button (click)="toggleDropdown()" class="rechtliches-button">
        <li class="lower-menu-items withDropdown">
          <div class="menu-icons"></div>
          <div class="menutext">Rechtliches</div>
          <div class="chevron" [class.open]="isDropdownOpen" [ngStyle]="{
      'mask-image': 'url(/assets/chevron-right.svg)',
      '-webkit-mask-image': 'url(/assets/chevron-right.svg)'
    }"
            >&#9662;
          </div> <!-- Downward chevron -->
        </li>
      </button>

      <!-- Dropdown items -->
      @if (isDropdownOpen) {
        <ul class="dropdown-submenu">
          <li><a target="_blank" href="https://energyplus.at/impressum/" (click)="close()">Impressum</a></li>
          <li><a target="_blank" href="https://energyplus.at/datenschutz/" (click)="close()">Datenschutz</a></li>
          <li><a target="_blank" href="https://energyplus.at/agb/" (click)="close()">AGB</a></li>
        </ul>
      }


    </ul>

  </mat-sidenav>
  <mat-sidenav-content>
    <p>content, not visible</p> <!-- but needs to be here-->
  </mat-sidenav-content>
</mat-sidenav-container>

